import type { ResolvedWizardBlock, RenderBlockFn, BlockRendererSharedProps } from '../types/blocks';
import { WizardBlockRendererV2 } from './v2/WizardBlockRendererV2';
import type { WizardBlockV2 } from './v2/types';

export interface WizardBlockRendererProps extends BlockRendererSharedProps {
  block: ResolvedWizardBlock;
  renderBlock: RenderBlockFn;
}

export function WizardBlockRenderer({
  block,
  renderBlock,
  params,
  meta,
  onSuccess,
  onError,
  onCancel,
}: WizardBlockRendererProps): JSX.Element {
  return (
    <WizardBlockRendererV2
      block={block as unknown as WizardBlockV2}
      renderBlock={renderBlock}
      params={params}
      meta={meta}
      onSuccess={onSuccess}
      onError={onError}
      onCancel={onCancel}
    />
  );
}
